




























































import {reactive} from '@vue/composition-api'
import {AppData} from "./data2.js";
import {staticPath} from "./utils";
import VueFlowEditorModel from './flow-editor-model.vue'

const Ele = (window as any).ELEMENT
const G6 = (window as any).G6.default as any

function delay(time) {
    return new Promise((resolve) => setTimeout(resolve, time))
}

export default {
    components: {
        VueFlowEditorModel
    },
    name: "App.vue",
    setup(props, context) {

        const state = reactive({
            data: {},
            detailModel: {type: '', data: {}},
            editorLoading: false,

            selectOptions: [
                {label: '待确认', value: '0'},
                {label: '填写表单', value: '1'},
                {label: '部门负责人审批', value: '2'},
                {label: '总经理审批', value: '3'},
            ],
            menuData: [
                {
                    label: '流程节点',
                    menus: [
                        {name: '提交节点', label: '提交', shape: 'ellipse', type: 'start-node', img: staticPath('/images/start-node.png'), id: generateId},
                        {name: '审批节点', label: '审批', shape: 'rect', type: 'approval-node', img: staticPath('/images/flow-node.png'), id: generateId},
                        {name: '经办节点', label: '经办', shape: 'hexagon', type: 'handle-node', img: staticPath('/images/flow-node.png'), id: generateId},
                        {name: '条件判定节点', label: '判定', shape: 'diamond', type: 'judge-node', img: staticPath('/images/judge-node.png'), id: generateId},
                        {name: '结束节点', label: '结束', shape: 'ellipse', type:'end-node', img: staticPath('/images/end-node.png'), id: generateId},
                    ],
                },
            ],
            activityConfig: {},
            showSelfModel: false
        })

        let editor;

        function onDblclickNode(e) {

            const model = G6.Util.clone(e.item.get('model'))
            // 开始节点和结束节点不编辑
            if (model.type === 'start-node' || model.type === 'end-node') {
                return false
            }
            if (model.type === 'approval-node') {
                const defaultData = [{
                    type: 'staff',
                    typeName: '员工',
                    approvalValue: null
                }, {
                    type: 'role',
                    typeName: '角色',
                    approvalValue: null
                }];
                if (!model.hasOwnProperty('data') || !model.data) {
                    model.data = {
                        approvalData: defaultData
                    };
                } else {
                    const data = model.data;
                    if (!data.hasOwnProperty('approvalData')) {
                        model.data = {
                            ...data,
                            approvalData: defaultData
                        };
                    }
                }
            } else {
                if (!model.hasOwnProperty('data') || !model.data) {
                    model.data = {};
                }
            }

            state.detailModel = model
            state.showSelfModel = true
            // editor.openModel()
        }

        function onDblClickEdge(e) {
            const sourceNode = e.item.get('sourceNode');
            const sourceNodeModel = sourceNode.get('model');
            const sourceType = sourceNodeModel.type;

            // 连接线中只有分支条件线支持编辑
            if (sourceType !== 'judge-node') {
                return false
            }

            const model = e.item.get('model')
            model.type = e.item.get('type')
            model.id = e.item.get('id')

            const defaultData = [{
                link: null,
                leftParenthesis: false,
                field: null,
                condition: null,
                compareObj: null,
                rightParenthesis: false,
                judgeCondition: []
            }];
            if (!model.hasOwnProperty('data') || !model.data) {
                model.data = {
                    conditionData: defaultData
                };
            } else {
                const data = model.data;
                if (!data.hasOwnProperty('conditionData')) {
                    model.data = {
                        ...data,
                        conditionData: defaultData
                    };
                }
            }

            state.detailModel = model
            state.showSelfModel = true
            // editor.openModel()
        }

        function cancel() {
            state.showSelfModel = false
            // editor.closeModel()
        }

        function save() {
            editor.updateModel(state.detailModel, false)
            state.showSelfModel = false
            // editor.closeModel()
        }

        async function handleBeforeDelete(model, type) {
            // if (type === 'node') {
            //     if (model.type === 'start-node') {
            //         Ele.Notification.error('不可以删除【提交】节点')
            //         return Promise.reject('reject')
            //     }
            // }
        }

        function handleAfterDelete(model, type) {
            if (type === 'edge') {
                console.log('delete edge')
            } else {
                console.log('after delete', model.label, {...model})
            }
        }

        function handleBeforeAdd(model, type) {
            if (type === 'edge') {
                if (model.sourceType === 'end-node') {
                    Ele.Notification.error('结束节点不能输出连线其他节点')
                    return Promise.reject('reject')
                }
                if (model.targetType === 'start-node') {
                    Ele.Notification.error({ title: '提示', message: '连线不能指向提交节点' })
                    return Promise.reject('reject')
                }

                const data = editor.editorState.graph.save()
                // 当添加的是提交节点和结束节点时，需要判断当前添加的节点是否已经存在
                const existEdges = data.edges.filter(edge => {
                    return (edge.source === model.source && edge.target === model.target) || (edge.source === model.target && edge.target === model.source);
                });
                if (existEdges.length > 0) {
                    Ele.Notification.error({ title: '提示', message: '当前两个节点已存在连线' })
                    return Promise.reject('当前两个节点已存在连线')
                }
            }
            if (type === 'node') {
                if (model.type === 'start-node' || model.type === 'end-node') {
                    const data = editor.editorState.graph.save()
                    // 当添加的是提交节点和结束节点时，需要判断当前添加的节点是否已经存在
                    const existNodes = data.nodes.filter(node => {
                        return node.type === model.type;
                    });
                    if (existNodes.length > 0) {
                        const nodeName = model.type === 'start-node' ? '提交' : '结束';
                        Ele.Notification.error({title: '提示', message: `添加“${nodeName}节点”失败，流程中只能存在一个“${nodeName}”节点`})
                        return Promise.reject('reject')
                    }
                }
            }
        }

        function handleAfterAdd(model, type) {
            if (type === 'edge') {
                console.log(`新增连接线`)
            }
        }

        function logData() {
            let {nodes, edges} = editor.editorState.graph.save()
            // nodes = nodes.map(({data, id, label, shape, x, y, text, desc, img, type}) => ({data, id, label, shape, x, y, text, desc, img, type}))
            // edges = edges.map(({data, source, sourceAnchor, target, targetAnchor}) => ({source, sourceAnchor, target, targetAnchor, data}))
            // console.log(JSON.stringify({nodes, edges}, null, 2))
            console.log(1111, {nodes, edges})
        }

        // 自定义节点id
        function generateId(type) {
            if (type) {
                return type + String(new Date().getTime())
            }
            return String(new Date().getTime())
        }

        function refresh() {
            state.data = {...AppData}
            editor.changeData({...AppData})
        }

        return {
            state,

            showGrid: true,
            showMiniMap: false,

            onDblclickNode,
            onDblClickEdge,
            cancel,
            save,
            handleBeforeDelete,
            handleAfterDelete,
            handleBeforeAdd,
            handleAfterAdd,

            logData,
            refresh,

            generateId,

            onRef: e => editor = e,
            staticPath,
        }
    },
}
